import { CanDeactivateFn } from '@angular/router';

export interface CanComponentDeactivate {
  hasUnsavedChanges: () => boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
) => {
  if (component && component.hasUnsavedChanges && component.hasUnsavedChanges()) {
    return confirm(
      'You have unsaved changes. Are you sure you want to leave? Your changes will be lost.'
    );
  }
  return true;
};
